/* Exact approved Kanna story and menu behavior, inside an isolated visual foundation. */
(() => {

/* Allow marked draft-page and research links; submissions stay inactive. */
document.addEventListener('click', event => {
  const target = event.target instanceof Element ? event.target : event.target.parentElement;
  if (!target) return;
  if (target.closest('[data-nu-commerce], .nu-cart-open, [data-nu-add-to-cart], [data-nu-connected-form], [data-nu-connected-link]')) return;
  const link = target.closest('a[href]');
  const href = link && link.getAttribute('href');
  const outboundLink = link && !link.hasAttribute('data-nu-preview-link') && !link.hasAttribute('data-nu-research-link') && !(href && href.startsWith('#'));
  const inactive = target.closest('[data-kanna-foundation-disabled], [name=add], [data-add-to-cart], .shopify-payment-button, [name=checkout], [data-cart-checkout]');
  if (!inactive && !outboundLink) return;
  event.preventDefault();
  event.stopImmediatePropagation();
}, true);
document.addEventListener('submit', event => {
  if (event.target.matches('form[data-nu-connected-form]')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
}, true);

/* Source: build_assets/kanna-story/refined-draft.js */
(() => {
  const chapters = Array.from(document.querySelectorAll('[data-chapter]'));
  const images = Array.from(document.querySelectorAll('[data-image]'));
  if (chapters.length !== images.length || !chapters.length) return;
  document.documentElement.classList.add('has-story-motion');
  let pending = false;
  let active = -1;
  function update() {
    pending = false;
    const visual = document.querySelector('.story-visual');
    const bottom = visual.getBoundingClientRect().bottom;
    const desktop = window.matchMedia('(min-width: 768px)').matches;
    // Desktop follows the incoming heading beside the photo. Mobile keeps its approved reading line.
    const focus = desktop
      ? visual.getBoundingClientRect().top + visual.getBoundingClientRect().height * 0.5
      : bottom + Math.min(96, Math.max(0, window.innerHeight - bottom) * 0.22);
    let nearest = 0;
    chapters.forEach((chapter, index) => {
      const anchor = desktop ? chapter.querySelector('.eyebrow') : chapter;
      if (anchor.getBoundingClientRect().top <= focus + 1) nearest = index;
    });
    if (nearest === active) return;
    active = nearest;
    images.forEach((image, index) => {
      image.classList.toggle('is-active', index === active);
      image.setAttribute('aria-hidden', String(index !== active));
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule, { once: true });
  document.fonts.ready.then(schedule);
  update();
})();


/* Source: build_assets/shared-site-chrome/mobile-navigation.js */
/* Shared dropdown navigation for desktop and mobile. */
(() => {
  const header = document.querySelector('header.numuti-header');
  if (!header) return;
  const toggle = header.querySelector('.mobile-menu-toggle');
  const navigation = header.querySelector('#numuti-mobile-menu');
  if (!toggle || !navigation) return;
  const mobile = window.matchMedia('(max-width: 767px)');
  let open = false;

  function render() {
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    navigation.hidden = !open;
  }
  function close(returnFocus = false) {
    open = false;
    render();
    if (returnFocus) toggle.focus();
  }

  toggle.hidden = false;
  header.classList.add('mobile-nav-ready');
  render();
  toggle.addEventListener('click', () => {
    open = !open;
    render();
  });
  toggle.addEventListener('keydown', event => {
    if (event.key !== 'ArrowDown') return;
    event.preventDefault();
    open = true;
    render();
    navigation.querySelector('a[href]')?.focus();
  });
  navigation.addEventListener('click', event => {
    if (event.target.closest('a[href]')) close();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && open) {
      event.preventDefault();
      close(true);
    }
  });
  document.addEventListener('click', event => {
    if (open && !header.contains(event.target)) close();
  });
  header.addEventListener('focusout', () => {
    requestAnimationFrame(() => {
      if (open && !header.contains(document.activeElement)) close();
    });
  });
  mobile.addEventListener('change', () => {
    const focusWasInNavigation = navigation.contains(document.activeElement);
    close(focusWasInNavigation);
  });
})();

})();
